// extracted by mini-css-extract-plugin
module.exports = {"news-details":"news-page_news-details__NFBoy","name":"news-page_name__3wOuZ","details":"news-page_details__1MRbU","info":"news-page_info__18uIn","next":"news-page_next__10Ba1"};